import { render, staticRenderFns } from "./TransferPreview.vue?vue&type=template&id=27a14044&scoped=true&"
import script from "./TransferPreview.vue?vue&type=script&lang=js&"
export * from "./TransferPreview.vue?vue&type=script&lang=js&"
import style0 from "./TransferPreview.vue?vue&type=style&index=0&id=27a14044&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a14044",
  null
  
)

export default component.exports